import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  delivery_slips: [],
  delivery_slip_items: [],
  delivery_slip: {
    purchase_order_id: null,
    sequence: null

  },
  filtersData: {
    vendors: [],
    addresses: [],
    orders_no: []
  },
  total: 0
}

// getters
export const getters = {
  filtersData: state => state.filtersData,
  delivery_slips: state => state.delivery_slips,
  delivery_slip: state => state.delivery_slip,
  delivery_slip_items: state => state.delivery_slip_items,
  total: state => state.total
}

// mutations
export const mutations = {
  ADD_DELIVERY_SLIP (state, data) {
    state.delivery_slip = data
  },

  FILTERS_DATA (state, data) {
    state.filtersData = data
  },

  DELIVERY_SLIPS (state, data) {
    state.delivery_slips = data
  },

  DELIVERY_SLIP (state, data) {
    state.delivery_slip = data
  },
  DELIVERY_SLIP_ITEMS (state, data) {
    state.delivery_slip_items = data
  },

  TOTAL (state, data) {
    state.total = data
  }
}

// actions
export const actions = {

  async addDeliverySlip ({ commit }, data) {
    const response = await axios.put(laroute.route('create_delivery_slip',
      { companyAbbr: store.getters['auth/company'] }),
    data)
    commit('ADD_DELIVERY_SLIP', response.data.delivery_slip)
  },

  async fetchAll ({ commit }, filterData) {
    const { data } = await axios.get(laroute.route('delivery_slip_filter', { companyAbbr: store.getters['auth/company'], ...filterData }))
    commit('DELIVERY_SLIPS', data.items)
    commit('TOTAL', data.total)
  },

  async fetchFiltersData ({ commit }) {
    let payload = {
      vendors: state.filtersData.vendors,
      addresses: state.filtersData.addresses,
      orders_no: state.filtersData.orders_no
    }
    if (!state.filtersData.vendors.length) {
      const vendorsResponse = await axios.get(laroute.route('partners_name_list'))
      payload.vendors = vendorsResponse.data
    }
    if (!state.filtersData.addresses.length) {
      const addressesResponse = await axios.get(laroute.route('get_partner_stores_addresses'))
      payload.addresses = addressesResponse.data
    }
    if (!state.filtersData.orders_no.length) {
      const ordersResponse = await axios.get(laroute.route('get_orders_no', { companyAbbr: store.getters['auth/company'] }))
      payload.orders_no = ordersResponse.data
    }
    commit('FILTERS_DATA', payload)
  },

  async fetchOne ({ commit }, id) {
    const { data } = await axios.get(laroute.route('get_delivery_slip', {
      companyAbbr: store.getters['auth/company'],
      id
    }))
    commit('DELIVERY_SLIP', data.delivery_slip)
    commit('DELIVERY_SLIP_ITEMS', data.delivery_slip_items)
  },

  async updateItem ({ commit }, { id, data }) {
    await axios.patch(laroute.route('update_delivery_slip', {
      companyAbbr: store.getters['auth/company'], id
    }), data)
  },

  async saveNewDeliverySlipItems ({ commit }, { id, items }) {
    const { data } = await axios.patch(laroute.route('create_new_delivery_slip_items', {
      companyAbbr: store.getters['auth/company'], id
    }), { items })

    commit('DELIVERY_SLIP_ITEMS', data)
  },
  async deleteDS ({ commit }, { id, reason }) {
    await axios.delete(laroute.route('delete_delivery_slip', {
      companyAbbr: store.getters['auth/company'], id, reason
    }))
  },

  async deleteDSItem ({ commit }, { id, reason }) {
    await axios.delete(laroute.route('delete_delivery_slip_item', {
      companyAbbr: store.getters['auth/company'], id, reason
    }))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/deliverySlip.js